import { render } from "./otherServicesTwo.vue?vue&type=template&id=be97514c"
import script from "./otherServicesTwo.vue?vue&type=script&lang=js"
export * from "./otherServicesTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__